import { faqItems } from '@/pages/home/mocks/data';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">你关心的都在这里</h2>
          <p className="text-foreground-500 mt-2 text-sm">关于51吃瓜APP的常见问题解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6">
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 font-bold flex-shrink-0">Q{idx + 1}.</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-5">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}